import React from 'react';

const SvgMinus = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <rect x="5" y="10" width="12" height="2" fill="#858d97" />
  </svg>
);

export default SvgMinus;
